<template>
  <BaseTag
    class="base-vote-ticket"
    :class="{ 'base-vote-ticket--pending': isPending, 'base-vote-ticket--final': isFinal }"
    :preset="isFinal ? 'primary' : isPending ? 'secondary' : 'soft'"
    :tone="tone"
    icon="vote"
  >
    {{ displayText }}
    <template v-if="isFinal" #append>
      <BaseIcon name="check" class="base-vote-ticket__check" />
    </template>
  </BaseTag>
</template>

<script>
import BaseIcon from '@/components/base/BaseIcon';
import BaseTag from '@/components/base/BaseTag.vue';
import { getGoNoGoVoteTone } from '@/util/tag-tones/go-nogo-tag';
import { getNameInitials } from '@/util/user-util';

export default {
  name: 'BaseVoteTicket',
  components: {
    BaseIcon,
    BaseTag,
  },
  props: {
    name: {
      type: String,
      default: '',
    },
    /** `go` | `nogo` | pending (empty). Also accepts API values like YES/NO/GO/NOGO. */
    vote: {
      type: String,
      default: '',
    },
    /** @deprecated Use `vote`. Kept so existing list callers keep working. */
    color: {
      type: String,
      default: '',
    },
    isFinal: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    voteValue() {
      return (this.vote || this.color || '').toLowerCase();
    },
    isGo() {
      return this.voteValue === 'go' || this.voteValue === 'yes';
    },
    isNogo() {
      return this.voteValue === 'nogo' || this.voteValue === 'no';
    },
    isPending() {
      return !this.isGo && !this.isNogo;
    },
    tone() {
      if (this.isGo) return getGoNoGoVoteTone('go');
      if (this.isNogo) return getGoNoGoVoteTone('nogo');
      return 'neutral';
    },
    initials() {
      return getNameInitials(this.name);
    },
    displayText() {
      return this.isFinal ? this.name : this.initials || this.name;
    },
  },
};
</script>

<style lang="scss">
.base-vote-ticket {
  &--pending {
    border: 1px dashed $color-neutral !important;
    background-color: $color-neutral-pale !important;
    color: $color-normal-pale !important;

    .base-icon {
      color: $color-neutral !important;
    }
  }

  &--final {
    text-transform: uppercase;
    font-weight: $font-weight-bold;
  }

  &__check {
    flex-shrink: 0;
    width: 14px;
    height: 14px;
  }
}
</style>
